import React, { Suspense } from 'react';

import { Icon } from '@rbilabs/universal-components';

import { Animation } from 'components/lottie-animations/favorite-loading';
import { theme } from 'styles/configure-theme';

import { LoadingContainer } from './styled';
import { IFavoriteIcon } from './types';

export const FavoriteIcon: React.FC<IFavoriteIcon> = ({
  isFavorite,
  disabled,
  loading,
  iconName = 'favoriteFill',
}) => {
  const color = !isFavorite || disabled ? theme.token('icon-disabled') : theme.token('icon-active');
  const icon = <Icon variant={iconName} color={color} />;
  const loadingIcon = (
    <Suspense fallback={icon}>
      <LoadingContainer>
        <Animation />
      </LoadingContainer>
    </Suspense>
  );
  return loading ? loadingIcon : icon;
};
